// Given an url like "data:image/svg+xml,%3Csvg" gives "<svg...".
export default function decodeSvgDataUrl(maybeSvgDataUrl) {
  if (maybeSvgDataUrl) {
    return decodeURIComponent(maybeSvgDataUrl).substring(19);
  }

  return null;
}
